import React from "react";

const CampaignStatusBadge = ({ status }) => {

    const getClass = () => {

        switch (status?.toLowerCase()) {

            case "running":
                return "status-running";

            case "scheduled":
                return "status-scheduled";

            case "draft":
                return "status-draft";

            case "paused":
                return "status-paused";

            case "completed":
                return "status-completed";

            case "cancelled":
                return "status-cancelled";

            default:
                return "status-default";
        }

    };

    return (
        <span className={getClass()}>
            {status}
        </span>
    );

};

export default CampaignStatusBadge;